/**
 * @generated SignedSource<<5c3b088ebe7d201a81358ecbe804e714>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issues_softwareReleasesVersionDetailIssueList_jiraVersionRefetch$data = {
  readonly devOpsSummarisedEntities?: {
    readonly providers: {
      readonly featureFlagProviders: ReadonlyArray<{
        readonly __typename: "DevOpsFeatureFlagProvider";
        readonly " $fragmentSpreads": FragmentRefs<"featureFlagsEmptyState_softwareReleasesVersionDetailIssueList_FeatureFlagEmptyStateExperienceModal">;
      } | null | undefined>;
    };
  } | null | undefined;
  readonly id: string;
  readonly " $fragmentType": "issues_softwareReleasesVersionDetailIssueList_jiraVersionRefetch";
};
export type issues_softwareReleasesVersionDetailIssueList_jiraVersionRefetch$key = {
  readonly " $data"?: issues_softwareReleasesVersionDetailIssueList_jiraVersionRefetch$data;
  readonly " $fragmentSpreads": FragmentRefs<"issues_softwareReleasesVersionDetailIssueList_jiraVersionRefetch">;
};

import versionDetailIssueListJiraVersionRefetchQuery_graphql from './versionDetailIssueListJiraVersionRefetchQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isDevopsFeatureDisabledInFedRamp"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [
        "node"
      ],
      "operation": versionDetailIssueListJiraVersionRefetchQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "issues_softwareReleasesVersionDetailIssueList_jiraVersionRefetch",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "isDevopsFeatureDisabledInFedRamp",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "concreteType": "DevOpsSummarisedEntities",
          "kind": "LinkedField",
          "name": "devOpsSummarisedEntities",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "concreteType": "DevOpsProviders",
                "kind": "LinkedField",
                "name": "providers",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "DevOpsFeatureFlagProvider",
                      "kind": "LinkedField",
                      "name": "featureFlagProviders",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "__typename"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "featureFlagsEmptyState_softwareReleasesVersionDetailIssueList_FeatureFlagEmptyStateExperienceModal"
                        }
                      ]
                    },
                    "action": "NONE",
                    "path": "devOpsSummarisedEntities.providers.featureFlagProviders"
                  }
                ]
              },
              "action": "NONE",
              "path": "devOpsSummarisedEntities.providers"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "67e86aee284b1de0db813afbd23b7bbc";

export default node;
